import axios from 'axios';
import { store } from '../store';
import { fmtReport } from '../common/utils/format';

export function getReports() {
  const { token } = store.getState().auth;
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/report/`,
    headers: { Authorization: `Token ${token}` },
  }).then(({ data = [] }) => data.map(d => fmtReport(d)));
}

export function fetchQSEmbedUrl(id, type) {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/quicksight/`,
    headers: { Authorization: `Token ${token}` },
    params: { id, type },
  });
}

export function fetchPublicQSEmbedUrl(state) {
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/public/quicksight/${state}/`,
  });
}

export function fetchPBIEmbedUrl(rid, gid) {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/powerbi/`,
    headers: { Authorization: `Token ${token}` },
    params: { rid, gid },
  });
}

export function getStatePermissionMap() {
  return axios({
    url: 'https://yi3zb3qnyhuefrnv2pgeqt6v340sjshe.lambda-url.us-east-1.on.aws/',
  }).then(({ data }) => data);
}

export function getZipcodeCoverageReport() {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/zipcode-coverage-report/`,
    headers: { Authorization: `Token ${token}` },
  });
}

export function getProfileReport() {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/appointment-profile-report/`,
    headers: { Authorization: `Token ${token}` },
  });
}
